import { Constants } from '../_constants/constants';
import { BaseParameterDto } from './base-parameter-dto';

export class ImpersonateParameterDto extends BaseParameterDto {
  userName: string;
  portalType: string = Constants.portalTypeCode;
}
